export function selectableRecord(record, reason, selectable = () => true) {
  return !!record && !reason(record) && selectable(record)
}
export function mergeOptions(options, additions, reduce) {
  const result = [...options]
  for (const record of additions) {
    const index = result.findIndex(item => reduce(item) === reduce(record))
    if (index < 0) result.push(record); else result.splice(index, 1, record)
  }
  return result
}
